export const cellKey = (r, c) => `${r},${c}`;

export function fmtSecs(s) {
  const n = Math.max(0, Math.floor(s || 0));
  return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, "0")}`;
}
